import { createSlice } from "@reduxjs/toolkit";
import { fetchBanners } from "../actions/BannersAction";

// Banners Slice
const bannersSlice = createSlice({
  name: "banners",
  initialState: {
    banners: [],
    isLoading: false,
    error: null
  },
  reducers: {
    clearBannersState: (state) => {
      state.banners = [];
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBanners.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBanners.fulfilled, (state, action) => {
        state.isLoading = false;
        state.banners = action.payload.data;
      })
      .addCase(fetchBanners.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload.message;
      });
  }
});

export const { clearBannersState } = bannersSlice.actions;
export default bannersSlice.reducer;  